import dimbox from 'dimbox';
import { getCookie, isSupportCookieStore } from '../shared/functions';
import constants from '../shared/constants';

document.addEventListener('DOMContentLoaded', async (): Promise<void> => {
    dimbox.setConfig({
        showDownloadButton: false,
        showFullscreenButton: false,
        iframeTemplate: '<div class="dimbox-iframe-container"><iframe src="{{src}}" class="dimbox-iframe" allow="autoplay; encrypted-media" allowfullscreen></iframe><div class="dimbox-caption">{{caption}}</div></div>',
        inlineTemplate: `<div class="dimbox-inline-container"><div class="dimbox-inline-content has-radius-large">{{content}}</div></div>`
    });

    const $videoPopups: NodeListOf<HTMLAnchorElement> = document.querySelectorAll<HTMLAnchorElement>('.video-popup');
    let videoPlayed: boolean = false;
    const cookieConsent: string = await getCookie(constants.cookies.consent);
    let hasConsent: boolean = cookieConsent === 'true';

    $videoPopups.forEach(($videoPopup: HTMLAnchorElement) => {
        const href: string | null = $videoPopup.getAttribute('href');
        const inlineTarget: string | undefined = $videoPopup.dataset.inlineTarget;

        $videoPopup.addEventListener('click', (e: MouseEvent) => {
            e.preventDefault();

            if (!href) return;

            if (hasConsent) {
                $videoPopup.href = href;
                dimbox.open($videoPopup);
                videoPlayed = true;
            } else if (inlineTarget) {
                $videoPopup.href = inlineTarget;
                dimbox.open($videoPopup);
            }
        });
    });

    if (isSupportCookieStore) {
        (window as any).cookieStore.addEventListener('change', async (event: { changed: Array<{ name: string; value: string }>, deleted: Array<{ name: string }> }) => {
            const occChanged = event.changed.find(c => c.name === constants.cookies.consent);
            const occDeleted = event.deleted.find(c => c.name === constants.cookies.consent);

            if (occChanged || occDeleted) {
                hasConsent = occChanged?.value === 'true';
                if (!cookieConsent && videoPlayed) window.location.reload();
            }
        });
    }
});
